import { useMemo, useState } from "react";
import { Field } from "../../../../externalComponents/tailwind/fieldset";
import { Text } from "../../../../externalComponents/tailwind/text";
import { TemplatePreview } from "../../../../externalComponents/TemplatePreview";

const TemplatePreviewMarkup = ({ template, data }) => {
  const [previewTemplate, setPreviewTemplate] = useState({
    header: "",
    body: "",
    footer: "",
    quickReply1: "",
    quickReply2: "",
    quickReply3: "",
    urlButton: "",
    urlButton2: "",
    isUrlButtonAtBottom: false,
    limitedTimeOffer: null,
    copyCodeButton: null,
  });

  const selectedCardsHeader = useMemo(() => {
    if (!template || !template.components) {
      return [];
    }
    const cardComponent = template?.components?.find(
      (c) => c.type === "CAROUSEL",
    );
    if (!cardComponent) {
      return [];
    }
    const { cards } = cardComponent;
    if (!cards || !cards.length) {
      return [];
    }
    return [cards[0].components?.find((c) => c.type === "HEADER")?.format];
  }, [template]);

  const {
    headerParam,
    bodyText,
    footerText,
    quickReplies,
    urlButton,
    urlButton2,
    isUrlButtonAtBottom,
    limitedTimeOffer,
    copyCodeButton,
  } = useMemo(() => {
    let _headerParam = "";
    let _bodyText = "";
    let _footerText = "";
    let _quickReplies = [];
    let _urlButton = "";
    let _urlButton2 = "";
    let _isUrlButtonAtBottom = false;
    let _limitedTimeOffer = null;
    let _copyCodeButton = null;
    let urlCount = 0;

    for (let component of template?.components || []) {
      switch (component.type) {
        case "HEADER":
          {
            if (component && component.format === "IMAGE") {
              _headerParam = "image";
            } else if (component && component.format === "VIDEO") {
              _headerParam = "video";
            }
          }
          break;

        case "BODY": {
          _bodyText = component.text || "";
          break;
        }

        case "FOOTER": {
          _footerText = component.text || "";
          break;
        }

        case "LIMITED_TIME_OFFER": {
          _limitedTimeOffer = component.limited_time_offer;
          break;
        }

        case "BUTTONS": {
          component?.buttons?.forEach((button, index) => {
            if (button.type === "COPY_CODE") {
              _copyCodeButton = { text: button.example[0] };
            } else if (button.type === "URL") {
              if (urlCount === 0) {
                _urlButton = button.text;
              } else if (urlCount === 1) {
                _urlButton2 = button.text;
              }
              urlCount++;
              _isUrlButtonAtBottom = index === component.buttons.length - 1;
            } else {
              _quickReplies.push(button.text);
            }
          });
          break;
        }

        default:
          break;
      }
    }

    return {
      headerParam: _headerParam,
      bodyText: _bodyText,
      footerText: _footerText,
      quickReplies: _quickReplies,
      urlButton: _urlButton,
      urlButton2: _urlButton2,
      isUrlButtonAtBottom: _isUrlButtonAtBottom,
      limitedTimeOffer: _limitedTimeOffer,
      copyCodeButton: _copyCodeButton,
    };
  }, [template]);

  if (bodyText && !previewTemplate.body) {
    setPreviewTemplate((prevTemplate) => ({
      ...prevTemplate,
      header: headerParam,
      body: bodyText,
      footer: footerText,
      quickReply1: quickReplies[0] || "",
      quickReply2: quickReplies[1] || "",
      quickReply3: quickReplies[2] || "",
      urlButton,
      urlButton2,
      isUrlButtonAtBottom,
      limitedTimeOffer,
      copyCodeButton,
    }));

  }

  return (
    <Field className="border rounded-customBorderRadius p-3 mt-5">
      <Text className=" text-lg font-bold mb-3">Preview</Text>
      <div>
        {previewTemplate && data && (
          <TemplatePreview
            selectedHeader={previewTemplate.header}
            body={previewTemplate.body}
            footer={previewTemplate.footer}
            quickReply1={previewTemplate.quickReply1}
            quickReply2={previewTemplate.quickReply2}
            quickReply3={previewTemplate.quickReply3}
            urlButton={previewTemplate.urlButton}
            urlButton2={previewTemplate.urlButton2}
            width="100%"
            imageUrl={data.whatsappTemplate?.headerParameters?.image?.link}
            videoUrl={data.whatsappTemplate?.headerParameters?.video?.link}
            isUrlButtonAtBottom={previewTemplate.isUrlButtonAtBottom}
            cards={data.whatsappTemplate?.cards}
            selectedCardsHeader={selectedCardsHeader}
            copyCodeButton={previewTemplate.copyCodeButton}
            limitedTimeOffer={previewTemplate.limitedTimeOffer}
            isLimitedTimeOffer={!!previewTemplate.limitedTimeOffer}
          />
        )}
      </div>
    </Field>
  );
};

export default TemplatePreviewMarkup;
